import React from 'react';
import { Button, Tooltip } from '@material-ui/core';
import FileCopyOutlined from '@material-ui/icons/FileCopyOutlined';

export type CopyTextButtonProps = {
  copyText: string;
  label?: React.ReactNode;
  tooltipText?: string;
  ariaLabel?: string;
};

export function CopyTextButton({ copyText, label, tooltipText, ariaLabel }: CopyTextButtonProps) {
  const [copyState, setCopyState] = React.useState<'idle' | 'success' | 'error'>('idle');
  const resetTimeoutRef = React.useRef<number | undefined>(undefined);

  React.useEffect(
    () => () => {
      if (resetTimeoutRef.current !== undefined) {
        window.clearTimeout(resetTimeoutRef.current);
      }
    },
    []
  );

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(copyText);
      setCopyState('success');
    } catch {
      setCopyState('error');
    }

    if (resetTimeoutRef.current !== undefined) {
      window.clearTimeout(resetTimeoutRef.current);
    }

    resetTimeoutRef.current = window.setTimeout(() => setCopyState('idle'), 1500);
  };

  const copyTooltipTitle =
    copyState === 'success'
      ? 'Copied'
      : copyState === 'error'
      ? 'Copy failed'
      : tooltipText || 'Copy';

  return (
    <Tooltip title={copyTooltipTitle} arrow>
      <Button
        size="small"
        onClick={handleCopy}
        aria-label={ariaLabel || `${tooltipText || 'Copy'} ${copyText}`}
        style={{ minWidth: 32, width: 32, height: 32, padding: 0 }}
      >
        {label || <FileCopyOutlined fontSize="small" />}
      </Button>
    </Tooltip>
  );
}
